<template>
  <ul class="actions-container">
    <header-link
      v-for="link in links"
      :key="link.to"
      :to="link.to"
      :label="link.label"
      class="link"
    />
  </ul>
</template>

<script>
import HeaderLink from '@/components/header/Link.vue';

export default {
  components: {
    HeaderLink,
  },
  props: {
    links: Array,
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/breakpoints';

.link {
  margin: 0 30px;
}

ul.actions-container {
  list-style-type: none;
  display: flex;
  justify-content: space-around;
  margin: 0;
}

@media (max-width: 1045px) {
  .link {
    margin: 0 10px;
  }
}

@media (max-width: $header-breakpoint) {
  ul.actions-container {
    display: none;
  }
}
</style>
